import { Banner } from '@boltenergy-be/design-system'
import { Trans, useTranslation } from 'react-i18next'
import { BillshockErrorProps } from './types.ts'
import Link from 'components/link/Link.tsx'
import { routes } from 'types/routes.ts'
import { isHandledBillShockTransfoError } from 'pages/app/billing/billing-cycles/components/billshock-error/utils.ts'

const BillshockError = ({ error }: BillshockErrorProps) => {
  // i18n
  const { t } = useTranslation('errors')

  // Constants
  const code = typeof error === 'object' ? ('status' in error ? error.status.toString() : error.code) : error

  return isHandledBillShockTransfoError(code) ? (
    <Banner type="informative">
      <Trans
        i18nKey={($) => $.transfo[code]}
        ns="errors"
        components={[<Link key="support" href={routes.SUPPORT_CONTACT} variant="inline" />]}
      />
    </Banner>
  ) : (
    <Banner type="warning">
      <p>{t(($) => $.tryAgain)}</p>
    </Banner>
  )
}

export default BillshockError
